import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";
import { ICommonQuestionsQuery } from "../../models/common-question/query";
import {
  ICreateCommonQuestion,
  IExportCommonQuestionsExcel,
  IUpdateCommonQuestion,
} from "../../models/common-question/request";
import {
  ICommonQuestion,
  ICommonQuestionsDetails,
} from "../../models/common-question/response";

class CommonQuestionservice<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllCommonQuestions = (
    query: ICommonQuestionsQuery,
    params?: RequestParams
  ) =>
    this.http.request<IBaseListingResponse<ICommonQuestion>>({
      path: `/common-question`,
      method: "GET",
      query,
      ...params,
    });

  getCommonQuestion = (id: number, params?: RequestParams) =>
    this.http.request<ICommonQuestionsDetails>({
      path: `/common-question/${id}`,
      method: "GET",
      ...params,
    });

  createCommonQuestion = (
    data: ICreateCommonQuestion,
    params?: RequestParams
  ) =>
    this.http.request<ICommonQuestion>({
      path: "/common-question",
      method: "POST",
      body: data,
      ...params,
    });

  updateCommonQuestion = (
    id: number,
    data: IUpdateCommonQuestion,
    params?: RequestParams
  ) =>
    this.http.request<ICommonQuestion>({
      path: `/common-question/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteCommonQuestion = (id: number, params?: RequestParams) =>
    this.http.request<ICommonQuestion>({
      path: `/common-question/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (
    data: IExportCommonQuestionsExcel,
    query: ICommonQuestionsQuery
  ) =>
    axios.post(
      ` ${process.env.REACT_APP_BASE_API_URL}/common-question/export`,
      data,
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN) ||
            sessionStorage.getItem(ACCESS_TOKEN)
            }`,
          "Content-Type": "application/json",
          "accept-language": `${localStorage.getItem(LANGUAGE_CODE) ??
            process.env.REACT_APP_DEFAULT_LANGUAGE
            }`,
        },
        params: query,
        responseType: "arraybuffer",
      }
    );
}

export default CommonQuestionservice;
